import React from "react";
import { LegalPersonType } from "@graphql";
import { FormField } from "@modules/formx-react";
import locale from "@bonliva-crm/locale";

import { Body } from "@components";
import { Switch } from "@components/formx";
import { Select, Text } from "@components/formx_item_form";

type Props = {
  legalPersonTypeName: string;
  businessName: string;
  businessSSNName: string;
  updateConsultantName: string;
  changeMessage: React.ReactNode;
  legalPersonTypeDisabled?: boolean;
};

export function BookingLegalPersonTypeSection(props: Props) {
  const { changeMessage, legalPersonTypeDisabled } = props;

  return (
    <FormField name={props.legalPersonTypeName}>
      {(field) => {
        return (
          <div>
            <Select
              name={props.legalPersonTypeName}
              label={locale["Employment type"]}
              options={Object.values(LegalPersonType).toLabelValue(
                (x) => locale.legalPersonType[x]
              )}
              disabled={legalPersonTypeDisabled}
            />

            {field.value === LegalPersonType.Subcontractor && (
              <div>
                <Text name={props.businessName} label={locale.BusinessName} />
                <Text
                  name={props.businessSSNName}
                  label={locale.BusinessSocialSecurityNo}
                />
              </div>
            )}

            {field.dirty && (
              <div>
                <Switch
                  name={props.updateConsultantName}
                  SwitchProps={{
                    disabled: !props.legalPersonTypeDisabled
                  }}
                  label={locale.UpdateConsultantWithSnapshotData}
                />

                <Body style={{ fontStyle: "italic" }}>{changeMessage}</Body>
              </div>
            )}
          </div>
        );
      }}
    </FormField>
  );
}
